import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TyreAdditionalState, TyreAdditionalStateValue, TyreStateResource } from '@data/tyres/tyres.model';

@Component({
  selector: 'app-deposit-payment-status',
  templateUrl: './deposit-payment-status.component.html',
  styleUrls: ['./deposit-payment-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepositPaymentStatusComponent {
  @Input() status: TyreStateResource<TyreAdditionalStateValue>;
  TyreAdditionalState = TyreAdditionalState;
}
